export default __webpack_public_path__ + "static/media/kratki_dluga.3979f5ed.png";